import styled from 'styled-components/macro'

import { fluidSystem, theme } from 'styled'

export const Root = styled.div`
  width: 300px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-height: 800px) {
    justify-content: flex-start;
  }
`

export const ThemeBoxRoot = styled.div`
  ${fluidSystem};
  &:not(:last-child) {
    border-bottom: 1px solid rgba(221, 221, 221, 0.5);
  }
`

export const IconWrapper = styled.div`
  overflow: hidden;
  height: ${({ selected }) => (selected ? 48 : 0)}px;
  transition: height 0.2s;
  color: ${theme.colors.primary};
  margin-bottom: 8px;

  > svg {
    width: auto;
    height: 48px;
    transform: translate(0, ${({ selected }) => (selected ? 0 : 100)}%);
    transition: transform 0.2s 0.2s;
  }
`

export const BoxHeading = styled.div`
  ${fluidSystem};
  width: 100%;
  text-transform: uppercase;
  display: flex;
  justify-content: space-between;
  align-items: center;
  pointer-events: ${({ selected }) => (selected ? 'none' : 'all')};
  overflow: hidden;
  &:hover {
    cursor: pointer;
  }
`

export const QuestionIcons = styled.div`
  display: flex;
  align-items: center;
  transform: translate(${({ selected }) => (!selected ? 0 : 100)}%, 0);
  transition: transform 0.3s 0.3s;

  > * + * {
    margin-left: 4px;
  }
`

export const QuestionsList = styled.div``

export const QuestionBoxRoot = styled.div`
  width: 100%;

  &:not(:last-child) {
    border-bottom: 1px solid rgba(221, 221, 221, 0.5);
  }
`

export const ContentInner = styled.div`
  width: 100%;
  height: ${({ open, openHeight }) => (open ? openHeight : 0)}px;
  overflow: hidden;
  transition: height 0.3s;
`
